const environment = {}

// 定义一个LX类，用于处理页面埋点
class LX {
  constructor() {
    // 初始化时关闭自动PV上报
    window.LXAnalytics('config', 'onWebviewAppearAutoPV', false)
  }

  // 页面PV上报方法
  pv(cid, lab = {}) {
    if (cid) {
      window.LXAnalytics('pageView', { ...lab }, environment, cid)
    }
  }

  // 页面点击事件上报方法
  click(bid, lab = {}, option = {}) {
    option.isH5 = true
    if (bid) {
      window.LXAnalytics('moduleClick', bid, { ...lab }, option)
    }
  }

  // 页面模块展示事件上报方法
  view(bid, lab = {}, option = {}) {
    option.isH5 = true
    if (bid) {
      window.LXAnalytics('moduleView', bid, { ...lab }, option)
    }
  }

  // 自定义标签上报方法
  tag(identifier, lab = {}) {
    window.LXAnalytics('tag', identifier, { ...lab })
  }

  // 带自定义标签的点击事件上报方法
  clickWithTag(category = 'offline_payment', bid, lab = {}, option = {}) {
    option.isH5 = true
    if (bid) {
      this.tag(category, { [option.cid]: { bid, ...lab } })
      window.LXAnalytics('moduleClick', bid, { ...lab }, option)
    }
  }

  // 系统检查事件上报方法
  sc(bid, lab = {}, option = {}) {
    window.LXAnalytics('systemCheck', bid, { ...lab }, option)
  }

  // BO 下单事件上报方法
  order(bid, orderId, lab = {}, option = {}) {
    window.LXAnalytics('order', bid, orderId, { ...lab }, option)
  }
}

// 导出LX类的实例
export default new LX()
